import { FC } from 'react';

import { ModalForm } from 'components/ModalForm';
import { useModal } from 'context/ModalProvider/useModal';
import { useDeleteContractorDeliveryPriceMutation } from 'pages/Contractor/api/services';
import { isSuccess } from 'utils/responseStatus';

type Props = {
  id: number;
  onRefresh: () => void;
};

export const DeleteContractorDeliveryPriceModal: FC<Props> = ({ id, onRefresh }) => {
  const { hideModal } = useModal();

  const [deleteContractorDeliveryPrice, { isLoading }] = useDeleteContractorDeliveryPriceMutation();

  const handleSubmit = () => {
    deleteContractorDeliveryPrice({ id }).then((data) => {
      if (isSuccess(data)) {
        onRefresh();
        hideModal();
      }
    });
  };

  return (
    <ModalForm
      onHidden={hideModal}
      onSubmit={handleSubmit}
      title="Удалить запись?"
      visible
      isLoadingSubmit={false}
      width={400}
      minHeight={130}
      textConfirm="Удалить"
      hideOnOutsideClick={false}
      disabledSubmit={isLoading}
      typeConfirm="danger"
    >
      <div>Подтвердите удаление</div>
    </ModalForm>
  );
};
